import { useState } from "react";

interface FormatOption {
  id: string;
  title: string;
  description: string;
  icon: string;
  iconColor: string;
}

const formats: FormatOption[] = [
  {
    id: "bexio",
    title: "Bexio CSV",
    description: "Swiss standard format",
    icon: "fa-solid fa-file-csv",
    iconColor: "text-brand-primary"
  },
  {
    id: "excel",
    title: "Excel Template", 
    description: "Customizable .xlsx file",
    icon: "fa-solid fa-file-excel",
    iconColor: "text-green-700"
  },
  {
    id: "datev",
    title: "DATEV Export",
    description: "For German systems",
    icon: "fa-solid fa-file-code",
    iconColor: "text-brand-primary"
  },
  {
    id: "custom",
    title: "Custom Format",
    description: "Create new template",
    icon: "fa-solid fa-plus",
    iconColor: "text-brand-primary"
  }
];

interface FormatSelectionProps {
  onNext: (format: string) => void;
}

export const FormatSelection = ({ onNext }: FormatSelectionProps) => {
  const [selectedFormat, setSelectedFormat] = useState<string>("bexio");

  return (
    <div>
      <h3 className="text-lg font-bold text-brand-primary mb-2 text-center">Select an Export Format</h3>
      <p className="text-brand-text-secondary text-sm mb-6 text-center">Choose a pre-configured template or create your own.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-header-mb">
        {formats.map((format) => (
          <div
            key={format.id}
            onClick={() => setSelectedFormat(format.id)}
            className={`p-4 bg-white rounded-xl border-2 cursor-pointer text-center transition-all duration-200 ${
              selectedFormat === format.id
                ? 'border-brand-primary shadow-lg'
                : 'border-brand-border hover:border-brand-primary'
            }`}
          >
            <div className="w-16 h-16 bg-brand-secondary rounded-lg mx-auto flex items-center justify-center mb-3">
              <i className={`${format.icon} text-3xl ${format.iconColor}`}></i>
            </div>
            <h4 className="font-bold text-brand-text-primary">{format.title}</h4>
            <p className="text-xs text-brand-text-secondary">{format.description}</p>
          </div>
        ))}
      </div>

      <div className="flex justify-center">
        <button
          onClick={() => onNext(selectedFormat)}
          className="px-6 py-3 bg-brand-primary text-white rounded-lg font-medium hover:bg-brand-primary/90 transition-colors"
        >
          Continue to Scope Selection
        </button>
      </div>
    </div>
  );
};